import React, { useEffect, useState } from 'react';
import {
  Form,
  Row,
  Modal,
  Button,
  Space,
  InputNumber,
  Typography,
  Select,
} from 'antd';
import { FormLabel } from 'components/common';
import { SmartBackButton } from '../../SmartComponent';
import { useTranslation } from 'react-i18next';

interface CreateBrandProps {
  visible: boolean;
  onHide: () => void;
  onUpdate: (value: any) => void;
  onDelete: (id: string) => void;
  info: any;
  lotEnable: boolean;
  uomEnable: boolean;
}
// eslint-disable-next-line
export default (props: CreateBrandProps) => {
  const { visible, onHide, onUpdate, info, lotEnable, uomEnable, onDelete } =
    props;
  const { t } = useTranslation();
  const [selectedUom, setSelectedUom] = useState<any>();
  const [qty, setQty] = useState(info.qty);

  const [form] = Form.useForm();

  const handleSave = async () => {
    const formValue = form.getFieldsValue();
    const id = `${info?.sku}-${formValue?.lotNumber || ''}-${
      formValue?.uom || ''
    }`;
    onUpdate({
      ...info,
      id,
      lotNumber: formValue.lotNumber,
      uom: formValue.uom,
      rate: selectedUom?.uomRate || 1,
      qty: qty,
    });
  };

  useEffect(() => {
    if (info.uom) {
      const temp = info.uomList.filter((i: any) => i.uom === info.uom);
      if (temp.length > 0) {
        setSelectedUom(temp[0]);
      }
    }
  }, [info]);

  return (
    <Modal
      title="Edit Location Count"
      centered
      visible={visible}
      maskClosable={false}
      style={{ width: '80%', maxWidth: 300 }}
      destroyOnClose={true}
      onCancel={onHide}
      getContainer={false}
      footer={
        <Row justify="end">
          <Space>
            <Button key="submit" type="primary" onClick={handleSave}>
              {t('common.update')}
            </Button>
            <Button onClick={onHide}>{t('common.cancel')}</Button>
          </Space>
        </Row>
      }
    >
      <Form form={form}>
        <Row justify="start" style={{ marginBottom: 8 }}>
          <FormLabel>{t('common.sku')}</FormLabel>
          <Typography.Text>{info.sku}</Typography.Text>
        </Row>
        <Row justify="start" style={{ marginBottom: 8 }}>
          <FormLabel>{t('common.upc')}</FormLabel>
          <Typography.Text>{info.upc}</Typography.Text>
        </Row>

        {lotEnable && (
          <Row justify="start" style={{ marginBottom: 8 }}>
            <FormLabel>{t('common.lotNumber')}</FormLabel>
            <Space>
              <Form.Item noStyle name="lotNumber" initialValue={info.lotNumber}>
                <Select disabled style={{ width: 200, marginLeft: 4 }}>
                  {info.lotNumberList.map((i: any) => (
                    <Select.Option key={i.productLotNum} value={i.lotNumber}>
                      {i.lotNumber}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Space>
          </Row>
        )}

        {uomEnable && (
          <Row justify="start" style={{ marginBottom: 8 }}>
            <FormLabel>{t('common.uom')}</FormLabel>
            <Space>
              <Form.Item noStyle name="uom" initialValue={info.uom}>
                <Select
                  disabled
                  style={{ width: 100, marginLeft: 4 }}
                  onChange={(value) => {
                    if (value) {
                      const temp = info.uomList.filter(
                        (i: any) => i.uom === value
                      );
                      setSelectedUom(temp[0]);
                    }
                  }}
                >
                  {info.uomList.map((i: any) => (
                    <Select.Option key={i.productUomNum} value={i.uom}>
                      {i.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              {selectedUom && (
                <Typography.Text>
                  <FormLabel>Rate</FormLabel>
                  {selectedUom?.uomRate}
                </Typography.Text>
              )}
            </Space>
          </Row>
        )}

        <Row justify="start" style={{ marginBottom: 8 }}>
          <FormLabel>{t('common.qty')}</FormLabel>
          <Space>
            <Form.Item noStyle>
              <InputNumber
                min={1}
                value={qty}
                style={{ width: 100, marginLeft: 4 }}
                onChange={(e) => setQty(e)}
              />
            </Form.Item>

            {selectedUom && uomEnable && (
              <Typography.Text>
                <FormLabel>{t('common.baseQty')}</FormLabel>
                {qty * selectedUom.uomRate}
              </Typography.Text>
            )}
          </Space>
        </Row>
        <SmartBackButton>
          <Row>
            <Button danger onClick={() => onDelete(info.id)}>
            {t('common.delete')}
            </Button>
          </Row>
        </SmartBackButton>
      </Form>
    </Modal>
  );
};
